var app = new Vue({
  el: '#samples-cart-container',
  
  data: {
    product: typeof product !== 'undefined' ? product : {},
    samplesCart: [],
    maxSamples: 5,
    samplesFullMessage: "You have reached your maximum sample amount, to receive a sample of this tile please either remove another sample you have selected from your cart, or check out your current cart and start a new cart" 
  },
  
  computed: {
    sampleVariant: function() {

      var _this = this;
      if(!this.product.variants) return null

      return _this.product.variants.filter((variant) => {
        return variant.title.indexOf('Sample') !== -1;
      })[0] || null;
    }
  },
  
  mounted: function() {
    var _this = this;

    // Remove Sample option from dropdown
    $('#SingleOptionSelector-0').find('option[value*="Sample"]').remove();
    
    
    // Init event handler
    _this.initEventHandlers();
    
    // Get samples in cart
    _this.getSamplesInCart().then(function(samplesInCart) {
      _this.$set(_this, 'samplesCart', samplesInCart);
    });
  },
  
  methods: {
    getCart: function() {
      return $.getJSON('/cart.js');
    },
    
    getSamplesInCart: function() {
      return new Promise(function(resolve, reject) {
        $.getJSON('/cart.js', function(data) {
          var samplesInCart = data.items.filter((item) => {
            return item.title.toLowerCase().indexOf('sample') !== -1;
          });
          
          resolve(samplesInCart);
        });
      });
    },
    
    initEventHandlers: function() {
      var _this = this;

      // Add Sample to Cart
      $('.sample-add-to-cart').on('click', function(e) {
        e.preventDefault();
        var samplesCart = _this.samplesCart;
        
        if (samplesCart.length == _this.maxSamples) {
          alert(_this.samplesFullMessage);
          return false;
        }
        
        _this.addItemToCart({
          quantity: 1,
          variant_id: _this.sampleVariant.id
        })
        .then(function() {
          // change button
          $(e.currentTarget).prop('disabled', true);

          _this.showCart();
        });        
      });
    },
    
    addItemToCart: function(p_options) {
      var data = {
        quantity: p_options.quantity,
        id: p_options.variant_id,
      };

      if (p_options.properties !== undefined) {
        data['properties'] = p_options.properties
      }
      //console.log(data);

      return new Promise(function(resolve, reject) {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function(data) { 
            resolve(data);
          },
          error: function(error) { 
            reject(error);
          }
        });
      });      
    },
    
    removeItemFromCart: function(p_options) {
      var updates = {};
      updates[p_options.key] = 0;

      //console.log(updates);
      return new Promise(function(resolve, reject) {
        $.post('/cart/update.js', {
          updates: updates, 
          success: function(data) {
            resolve(data);
          }
        });
      });
    },
    
    showCart: function() {
      var _this = this;
      // Get samples in cart
      _this.getSamplesInCart().then(function(samplesInCart) {
        _this.$set(_this, 'samplesCart', samplesInCart);
        //console.log(samplesInCart);
        
        $('.samples-cart').addClass('active');        
      });      
    },
    
    hideCart: function(e) {
      if (e !== undefined) {
        e.preventDefault();
      }
      
      $('.samples-cart').removeClass('active');
    },    
    
    isSampleInCart: function(sample) {
      //console.log(sample);
      var _this = this;
      var sampleInCart = _this.samplesCart.filter((item) => {
        return item.id == _this.sampleVariant.id;
      });
      
      return sampleInCart.length !== 0;
    },
    
    removeSampleFromCart: function(e, item) {
      var _this = this;
      e.preventDefault;
      
      var removeItem = _this.samplesCart.filter((cartItem) => {
        return cartItem.id === item.id;
      });
      //console.log(removeItem);
      
      if (removeItem.length) {
        _this.removeItemFromCart({
          key: removeItem[0].key
        })
        .then(function() {
          setTimeout(_this.showCart, 200);
        });
      }
    },
    
    samplesCheckout: function(e) {
      e.preventDefault();
      
      window.location.href = '/checkout';
    }
  },
  
  filters: {
    resize: function(src, size) {
      var resized = src;
      resized = resized.replace('.png', `_${size}.png`);
      resized = resized.replace('.jpg', `_${size}.jpg`);
      return resized;
    },
    
    money: function(value) {
      value = parseFloat(value/100);
      var formatted = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(value);
      formatted = formatted.replace('.00', '');
      return formatted;
    },

    handle: function(value) {
      return value.toLowerCase().replace(' ', '-');
    },
    
    unhandle: function(value) {
      return value.replace('-', ' ');
    }    
  }
});